import {
  ContentIndexTypeEnum,
  ContentTypeEnum,
  IStaticContext,
  IStaticData,
  ITableDataIndexType,
  TitleLevelEnum,
} from "@/static/dataType";

const data: Array<IStaticData> = [
  {
    title: {
      text: "OAuth2.0認証について",
    },
    content: [
      {
        text: "当サイトでは、2つの認証方式（APIキー / OAuth2.0）のいずれかを選んでアプリケーションを作成することができます。",
        styleObject: { fontWeight: 500 },
      },
      {
        text: "APIキー認証とOAuth2.0認証には以下のような違いがあります。Safieの映像データを自社のSaaSへ組み込みたいなど、本格的な開発を行う場合はOAuth2.0認証を選ぶのがお勧めです。",
      },
      {
        type: ContentTypeEnum.table,
        table: {
          pcTable: {
            column: [
              {
                prop: "column1",
                label: "",
                width: "194",
              },
              {
                prop: "column2",
                label: "APIキー認証",
              },
              {
                prop: "column3",
                label: "OAuth2.0認証",
              },
            ],
            data: [
              {
                column1: [
                  {
                    text: "想定される用途例",
                  },
                ],
                column2: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "録画した映像データから定期的に静止画を取得できるようにしたい",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "映像上で何かを検知した時の動画を取得できるようにしたい",
                  },
                ],
                column3: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "独自のアプリケーションを開発して自社SaaSへ組み込みたい",
                  },
                ],
              },
              {
                column1: [
                  {
                    text: "こんな方におすすめ",
                  },
                ],
                column2: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "最小限の実装でAPIを試してみたい方",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "自社SaaSを持たない方",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "連携デバイス管理をセーフィーにまかせたい方",
                  },
                ],
                column3: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "より強固なセキュリティで運用したい方",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "Safieと自社SaaSを連携させたい方",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "連携デバイス管理を自社システムで行いたい方",
                  },
                ],
              },
            ],
          },
          spTable: [
            {
              column: [
                {
                  prop: "column1",
                  label: "",
                  width: "100",
                },
                {
                  prop: "column2",
                  label: "APIキー認証",
                },
              ],
              data: [
                {
                  column1: [
                    {
                      text: "想定される用途例",
                    },
                  ],
                  column2: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "録画した映像データから定期的に静止画を取得できるようにしたい",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "映像上で何かを検知した時の動画を取得できるようにしたい",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "こんな方におすすめ",
                    },
                  ],
                  column2: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "最小限の実装でAPIを試してみたい方",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "自社SaaSを持たない方",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "連携デバイス管理をセーフィーにまかせたい方",
                    },
                  ],
                },
              ],
            },
            {
              column: [
                {
                  prop: "column1",
                  label: "",
                  width: "100",
                },
                {
                  prop: "column3",
                  label: "OAuth2.0認証",
                },
              ],
              data: [
                {
                  column1: [
                    {
                      text: "想定される用途例",
                    },
                  ],
                  column3: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "独自のアプリケーションを開発して自社SaaSへ組み込みたい",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "こんな方におすすめ",
                    },
                  ],
                  column3: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "より強固なセキュリティで運用したい方",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "Safieと自社SaaSを連携させたい方",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "連携デバイス管理を自社システムで行いたい方",
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
      {
        text: "この仕組みにより、カメラ契約者にIDとパスワードを入力してもらうことで、ディベロッパーはカメラより保存された情報へアクセスをすることができます。",
        styleObject: { fontWeight: 500 },
      },
      {
        type: ContentTypeEnum.image,
        image: {
          pcUrl: require("./images/oauth1.png"),
          pcMaxWidth: "600px",
          pcWidth: "100%",
          spUrl: require("./images/oauth1.png"),
          spWidth: "319px",
          spMaxWidth: "319px",
        },
      },
    ],
  },
  {
    title: {
      text: "アプリケーションの新規作成",
    },
    children: [
      {
        title: {
          text: "1. 新規作成を開始",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "アプリケーション一覧画面から、OAuth2.0認証アプリケーションの「アプリケーション新規作成」ボタンをクリック（タップ）してください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/applications.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/applications-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
      {
        title: {
          text: "2. アプリケーション名称を入力",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "アプリケーションの名称を入力してください。",
            styleObject: { marginLeft: "24px" },
          },
        ],
      },
      {
        title: {
          text: "3. 利用したいAPIおよびSDK(JavaScript)にチェック",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "ご利用になりたいAPIおよびSDK(JavaScript)にチェックを付けてください。APIおよびSDK(JavaScript)ごとに「サービス利用者の許可が必要になる権限」が定められていますのでご確認ください。各機能の種類はリファレンスをご確認ください。",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
          },
          {
            text: "<a href='/reference/api' class='is-static-link' target='_blank'>APIリファレンス</a>",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
            indexType: ContentIndexTypeEnum.circle,
          },
          {
            text: "<a href='/reference/sdk' class='is-static-link' target='_blank'>SDK(JavaScript)リファレンス</a>",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
            indexType: ContentIndexTypeEnum.circle,
          },
          {
            text: "すべてのSafie APIおよびSafie SDK(JavaScript)を利用できるようにしておきたい場合は、「現在及び今後追加されるすべてのSafie APIおよびSDKを利用する」を有効にしてください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            text: "なお、1つのアプリケーションにSafie API「Live v2」とSDK(JavaScript)「Player」を同時に設定をすることはできません。どちらを利用するか指定してください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/oauth2.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/oauth2-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
      {
        title: {
          text: "4. 利用したいAPIおよびSDK(JavaScript)に合わせて必要なデバイスオプションを選択",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "画像取得API（月間リクエスト数）など、利用したいAPIおよびSDK(JavaScript)によってはデバイスオプションを複数の中から選択いただく必要があります。オプションに関してはこちらをご確認ください。トライアルプランの場合はこのステップは必要ありません。",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
          },
          {
            text: "<a href='/terms-of-api' class='is-static-link' target='_blank'>APIのオプション名一覧</a>",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
            indexType: ContentIndexTypeEnum.circle,
          },
          {
            text: "<a href='/terms-of-api/sdk' class='is-static-link' target='_blank'>SDK(JavaScript)のオプション名一覧</a>",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
            indexType: ContentIndexTypeEnum.circle,
          },
        ],
      },
      {
        title: {
          text: "5. 内容を確認して新規作成",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "入力内容を確認の上、「この内容で新規作成」をクリック（タップ）してください。新規作成が完了するとScopeが表示されます。Scopeは認可コード取得時に利用します。Scopeはアプリケーションの設定画面からも確認できます。続いてClient ID/Secretの取得へと進みます。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/oauth4.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/oauth4-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
    ],
  },
  {
    title: {
      text: "Client ID/Secretの取得",
    },
    content: [
      {
        text: "アプリケーション作成後、「Client新規作成」をクリック（タップ）してください。Redirect URIを記入して「発行」ボタンをクリック（タップ）してください。",
      },
      {
        text: "Redirect URIは後述の認可コード取得の際のリダイレクト先となるものです。アクセストークンを管理したいWebページのURLを記入してください。",
      },
      {
        text: "Client ID/Secretは2個まで作成することができます。開発/本番環境の使い分けなどにご利用ください。",
      },
    ],
  },
  {
    title: {
      text: "認可コードの取得",
    },
    content: [
      {
        text: "OAuth2.0認証を使ったアプリケーションをユーザーに利用してもらうには、ユーザー自身による認証手続きが必要となります。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "自社サービスの中に、Safieの認可用Webページに移動する仕組みをご用意ください。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "認可用Webページ上で、デバイスオーナーがSafieのIDとパスワードを入力して認証を許可すると、認可コードが発行されます。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "認可コードはRedirect URIへ遷移後のクエリパラメータに付与されます。",
      },
      {
        type: ContentTypeEnum["tip-link"],
        styleObject: { marginLeft: "24px" },
        text: "認可用エンドポイントの詳細は<a class='is-static-link' href='/reference/api' target='_blank'>こちらのドキュメント</a>を参考にしてください",
      },
    ],
  },
  {
    title: {
      text: "アクセストークン/リフレッシュトークンの取得",
    },
    content: [
      {
        text: "各種APIおよびSDK(JavaScript)を実行するためにはアクセストークンが必要です。",
      },
      {
        text: "ここまで取得したClient ID/Secret、認可コードを用いてアクセストークン取得APIを実行します。アクセストークン、アクセストークンの有効期限（ミリ秒）、リフレッシュトークンが取得できます。",
      },
      {
        type: ContentTypeEnum["tip-link"],
        text: "アクセストークン取得APIのリクエストとレスポンスの詳細は<a class='is-static-link' href='/reference/api#tag/Auth-v2/operation/post-v2-auth-token' target='_blank'>こちらのドキュメント</a>を参考にしてください",
      },
    ],
  },
  {
    title: {
      text: "アクセストークンの更新",
    },
    content: [
      {
        text: "リフレッシュトークンを利用して、アクセストークンのリフレッシュAPIを実行してください。アクセストークンを更新することができます。アクセストークンを更新し続けることで、毎回認可コードを取得する必要がなくなります。",
      },
      {
        type: ContentTypeEnum["tip-link"],
        text: "アクセストークンのリフレッシュAPIの詳細は<a class='is-static-link' href='/reference/api#tag/Auth-v2/operation/post-v2-auth-refresh-token' target='_blank'>こちらのドキュメント</a>を参考にしてください",
      },
    ],
  },
  {
    title: {
      text: "アクセス許可設定について",
    },
    content: [
      {
        text: "作成されたアプリケーションは、初期状態ではすべてのIPアドレスからAPIおよびSDK(JavaScript)を利用できる状態になっています。指定したIPアドレスからのみアクセスを許可するようにする場合は、「アクセス許可」よりソースIPアドレスを新規登録してください。",
      },
      {
        text: "SDK(JavaScript)をご利用の場合、アクセス許可設定を行うことを推奨しております。",
        type: ContentTypeEnum["tip-link"],
      },
      {
        type: ContentTypeEnum.image,
        styleObject: { marginLeft: "24px" },
        image: {
          pcUrl: require("./images/oauth5.png"),
          pcMaxWidth: "600px",
          pcWidth: "100%",
          spUrl: require("./images/oauth5-sp.png"),
          spWidth: "319px",
          spMaxWidth: "319px",
        },
      },
    ],
  },
];
const context: IStaticContext = {
  headerTitle: "OAuth2.0認証",
  headerIcon: require("./images/header-icon.svg"),
  data,
};
export default context;
